import { makeAutoObservable } from "mobx";
import { Ticket } from "core/types/ticket";

//TODO: Extend BaseStore or PagerStore
class TicketStore implements IPagerStore<Ticket> {
    hasError = false;
    hasLoaded = false;
    isLoading = false;
    items: Ticket[] = [];
    filteredItems: Ticket[] = [];
    filter = "";
    pageItems: Ticket[] = [];

    numPages = 0;
    currentPage = 0;
    itemsPerPage = 5;

    //Start item
    firstItemIndex = 0;

    private _numberOfItems = 0;

    constructor() {
        makeAutoObservable(this);
    }

    private _onUpdate(items: Ticket[]) {
        this._numberOfItems = items?.length ?? 0;
        this.numPages = this._numberOfItems > 0 ? Math.ceil(this._numberOfItems / this.itemsPerPage) : 0;
    }

    updateFilter(value: string) {
        this.filter = value;
        this.filteredItems = this.filterItems();
        this._onUpdate(this.filteredItems);
        this.updateCurrentPage(0);
    }

    updateIsLoading(value: boolean) {
        this.isLoading = value;
    }

    updateItems(value: Ticket[]) {
        this.items = value;
        this.filteredItems = this.filterItems();

        this._onUpdate(this.filteredItems);

        this.hasLoaded = true;

        this.updateCurrentPage(0);
    }

    updateErrorLoading(value: boolean) {
        this.hasError = value;
    }

    private filterItems() {
        const filteredQueries = this.filter ? this.items.filter((query: any) =>
            query.status.toLowerCase().includes(this.filter)
        ) : this.items;

        return filteredQueries
            .sort((a: Ticket, b: Ticket) => (a.created_at > b.created_at ? 1 : -1));
    }

    get hasTickets() {
        return this.hasLoaded && this.items.length > 0;
    }

    reset() {
        this.currentPage = 0;
        this.firstItemIndex = 0;
        this.filter = "";
    }

    updateCurrentPage(value: number) {
        this.currentPage = value;

        const startIndex = (value * this.itemsPerPage) % this._numberOfItems;
        const endIndex = startIndex + this.itemsPerPage;

        this.pageItems = this.filteredItems?.slice(startIndex, endIndex) ?? [];
    }

    clear() {
        this.items = [];
        this.pageItems = []
        this.reset();
    }
}

export default TicketStore;
